export const baseurl = 'https://digitalize.aiyd88.com'
export const appid = 'wx8c66fe3d771387ea'